import { useParams } from 'react-router-dom';
import projectsData from '../data/projectsData';
import '../styles.css';
import { useState, useEffect } from 'react';
import Lightbox from 'yet-another-react-lightbox';
import Zoom from 'yet-another-react-lightbox/plugins/zoom';
import "yet-another-react-lightbox/styles.css";

function ProjectDetail() {
  const { id } = useParams();
  const [index, setIndex] = useState(-1);
  const project = projectsData.find((p) => p.id === id);

  // for category tabs
  const hasCategories = !!project?.categories;
  const [activeCategory, setActiveCategory] = useState(0);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [id]);

  if (!project) {
    return <div className="gallery">Project not found</div>;
  }

  const preventDownload = (e) => e.preventDefault();

  // decide which images to show
  const activeImages = hasCategories
    ? project.categories[activeCategory].images
    : project.images;

  const slides = activeImages.map((src) => ({ src }));

  return (
    <section className="gallery-site">
      <h1 className="category-title">{project.title}</h1>

      {/* Category tabs — only show for projects that have categories */}
      {hasCategories && (
        <div className="category-tabs">
          {project.categories.map((cat, i) => (
            <button
              key={i}
              className={`category-tab ${i === activeCategory ? 'active' : ''}`}
              onClick={() => { setActiveCategory(i); setIndex(-1); }}
            >
              {cat.name}
            </button>
          ))}
        </div>
      )}

      <Lightbox
        index={index}
        open={index >= 0}
        close={() => setIndex(-1)}
        slides={slides}
        plugins={[Zoom]}
        zoom={{
          maxZoomPixelRatio: 3,
          zoomInMultiplier: 2,
          doubleTapDelay: 300,
        }}
        render={{
          buttonPrev: () => null,
          buttonNext: () => null,
          buttonZoom: () => null,
          slide: ({ slide }) => (
            <img
              src={slide.src}
              alt="Project"
              onContextMenu={preventDownload}
              style={{ maxWidth: "100%", maxHeight: "100%", userSelect: "none" }}
            />
          )
        }}
      />

      <div className="project-detail-container">
        {activeImages.map((imgSrc, i) => (
          <div
            key={i}
            className="project-image-item-single"
            onClick={() => setIndex(i)}
          >
            <img
              src={imgSrc}
              alt={`${project.title} ${i + 1}`}
              onContextMenu={preventDownload}
              loading="lazy"
            />
          </div>
        ))}
      </div>
    </section>
  );
}

export default ProjectDetail;